import React from 'react'
import { Badge } from 'react-bootstrap'

/**
 * Configuración de estados con variantes y iconos
 */
const ESTADO_CONFIG = {
  'Activo': { variant: 'primary', icon: 'bi-play-circle' },
  'Procesado': { variant: 'info', icon: 'bi-check-circle' },
  // Spec lotes-estado-en-proceso-mediciones-condicionales: nuevo estado que indica
  // que el equipo está siendo calibrado en un lote activo (no revertir manualmente).
  'En Proceso': { variant: 'info', icon: 'bi-gear-wide-connected' },
  'Finalizado': { variant: 'success', icon: 'bi-check-circle-fill' },
  'Aprobado': { variant: 'success', icon: 'bi-patch-check' },
  'Cancelado': { variant: 'danger', icon: 'bi-x-circle-fill' },
  'Pendiente': { variant: 'warning', icon: 'bi-pause-circle' },
  'Aplazado': { variant: 'secondary', icon: 'bi-hourglass' },
  'Entregado': { variant: 'dark', icon: 'bi-box-seam' },
  'No Finalizado': { variant: 'light', icon: 'bi-dash-circle', textClass: 'text-dark' }
}

/**
 * Componente Badge reutilizable para mostrar estados
 * 
 * @param {Object} props
 * @param {string} props.estado - Estado a mostrar (Activo, Procesado, Finalizado, etc.)
 * @param {boolean} [props.showIcon=true] - Mostrar icono junto al texto
 * @param {string} [props.size='sm'] - Tamaño del badge (sm, md, lg)
 * @returns {JSX.Element}
 * 
 * @example
 * <EstadoBadge estado="Activo" />
 * <EstadoBadge estado="Finalizado" showIcon={false} size="lg" />
 */
export const EstadoBadge = ({ estado, showIcon = true, size = 'sm' }) => {
  const config = ESTADO_CONFIG[estado] || { 
    variant: 'secondary', 
    icon: 'bi-question-circle',
    textClass: 'text-white'
  }
  
  // Clase de tamaño personalizada
  const sizeClass = size === 'lg' ? 'fs-6 px-3 py-2' : size === 'md' ? 'fs-7 px-2 py-1' : ''
  
  return (
    <Badge 
      bg={config.variant} 
      className={`d-inline-flex align-items-center gap-1 ${sizeClass} ${config.textClass || ''}`}
    >
      {showIcon && <i className={`bi ${config.icon}`} />}
      <span>{estado}</span>
    </Badge>
  )
}

export default EstadoBadge
